module.exports = __webpack_public_path__ + "img/Ancien canal damenee d'eau salee salines Villeroy-Sete-900-600.f3b71c93.png";